// extracted by mini-css-extract-plugin
module.exports = {"preview-cantainer-empty":"variables-preview_preview-cantainer-empty__F11kO","add-variables-button":"variables-preview_add-variables-button__3KCw6"};